app.directive('ngAffiliation', function () {
    return {
        restrict: 'E',
        templateUrl: '../app/modules/templates/afffiliationModal.html',
        link: {
            post: function ($scope, element, attr) {
                $scope.setAffiliation = function () {
                    if ($scope.selectedInstitute.userDefinedAffiliation.length > 0 && $scope.selectedInstitute.userDefinedAffiliation != $scope.selectedInstitute.InstitutionName) {
                        $scope.selectedInstitute.InstitutionName = $scope.selectedInstitute.userDefinedAffiliation;
                        $scope.selectedInstitute.InstitutionId = 2;
                        $scope.selectedInstitute.isAffiliationExists = true;
                    }
                    if ($scope.selectedInstitute.InstitutionName.length > 0 || $scope.selectedInstitute.userDefinedAffiliation.length > 0) {
                        if ($scope.isTeamManagementPage != undefined && $scope.isTeamManagementPage == true) {
                            $scope.profileData.eSpectraTeamAffiliationID = parseInt($scope.selectedInstitute.InstitutionId) > 0 ? $scope.selectedInstitute.InstitutionId : 2;
                            $scope.profileData.eSpectraTeamAffiliationName = $scope.selectedInstitute.InstitutionName != '' ? $scope.selectedInstitute.InstitutionName : $scope.selectedInstitute.userDefinedAffiliation;
                            if ($scope.selectedInstitute.InstitutionName != $scope.profileData.eSpectraOrigTeamAffiliationName && $scope.selectedInstitute.userDefinedAffiliation != $scope.profileData.eSpectraOrigTeamAffiliationName) {
                                $scope.isAffiliationChanged = true;
                            } else {
                                $scope.isAffiliationChanged = false;
                            }
                        } else {
                            $scope.profileData.InstitutionId = parseInt($scope.selectedInstitute.InstitutionId) > 0 ? $scope.selectedInstitute.InstitutionId : 2;
                            $scope.profileData.InstitutionName = $scope.selectedInstitute.InstitutionName != '' ? $scope.selectedInstitute.InstitutionName : $scope.selectedInstitute.userDefinedAffiliation;
                        }
                        $scope.profileForm.instituteName.$dirty = true;
                        $scope.profileForm.instituteName.$touched = true;
                        $scope.profileForm.instituteName.$valid = true;
                        $('#institution-info').removeClass('hide');
                        $('#affiliation').modal('hide');

                        if ($scope.isSAdmin != undefined && $scope.isSAdmin == true) {
                            $scope.isAffiliationDivActive = false;
                        }
                    }
                };

                $scope.clearAffiliationOnBackspace = function () {
                    if ($('#affiliationName').val().length <= 0 && $scope.profileData.InstitutionName.length <= 0) {
                        $scope.deSelectInstitute();
                    }
                }

                $scope.deSelectInstitute = function () {
                    $scope.profileData.InstitutionId = 1;
                    $scope.profileData.InstitutionName = '';
                    $scope.selectedInstitute.userDefinedAffiliation = '';
                    $scope.selectedInstitute.isAffiliationExists = false;
                    //$('#affiliationName').removeAttr('disabled');
                    $('#institution-info').addClass('hide');

                    $scope.profileForm.instituteName.$dirty = false;
                    $scope.profileForm.instituteName.$untouched = true;
                    $scope.profileForm.instituteName.$prestine = true;
                }
            },
            pre: function ($scope, element, attr) {
                var serviceBase = $scope.$root.buildConfig.aippsssApiBaseUrl;

                // Instantiate the Bloodhound suggestion engine
                var institutions = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: serviceBase + 'api/Account/institutions?query=%QUERY',
                        prepare: function (query, settings) {
                            settings.beforeSend = (function () {
                                $('.autopopulate-spinner').show();
                                $scope.selectedInstitute.userDefinedAffiliation = query;
                                $scope.selectedInstitute.isAffiliationExists = false;
                                if ($scope.profileData.admin && $scope.profileData.InstitutionName == '') {
                                    $scope.profileForm.instituteName.$dirty = true;
                                    $scope.profileForm.instituteName.$invalid = true;
                                }
                                else {
                                    $scope.profileForm.instituteName.$dirty = true;
                                    $scope.profileForm.instituteName.$valid = true;
                                }
                                $scope.$apply();
                            })();
                            return $.extend(settings, {
                                url: settings.url.replace('%QUERY', encodeURIComponent(query)),
                                error: function (jqxhr, textStatus, errorThrown) {

                                    $('.autopopulate-spinner').hide();
                                },
                                success: function (data, textStatus, jqxhr) {
                                }
                            });
                        },
                        clearRemoteCache: function clearRemoteCache() {
                            this.transport && Transport.resetCache();
                        },
                        filter: function (institutions) {
                            $('.autopopulate-spinner').hide();
                            return $.map(institutions, function (institution) {
                                return {
                                    value: institution.institutionName,
                                    institutionCity: institution.institutionCity,
                                    institutionState: institution.institutionState,
                                    institutionID: institution.institutionID,
                                    institutionCountryCode: institution.institutionCountryCode
                                };
                            });
                        }
                    }
                });

                // Initialize the Bloodhound suggestion engine
                institutions.initialize();

                $("#affiliationName").typeahead({
                    hint: false,
                    highlight: true,
                    minLength: 3
                },
            {
                displayKey: 'value',
                minLength: 3,
                limit: 10,
                dupChecker: true,
                source: institutions.ttAdapter(),
                templates: {
                    suggestion: function (data) {
                        return "<div>" + data.value + ", " + data.institutionCity + ", " + data.institutionState + ", " + data.institutionCountryCode + " </div>";
                    },
                    empty: [
                            '<div style="background-color: #eeeeee;padding: 2px 5px;color: #000;">',
                                '<div style="display:inline-block">No Items Found</div>',
                            '</div>'
                    ].join('\n')
                }
            }).bind('typeahead:selected', function (obj, datum, name) {

                $scope.selectedInstitute.InstitutionId = datum.institutionID
                $scope.selectedInstitute.InstitutionName = datum.value;
                $scope.selectedInstitute.isAffiliationExists = true;
                $scope.selectedInstitute.userDefinedAffiliation = "";
                $scope.$apply();
                return false;
            });
            }
        }


    };
});
